
import { Component, Vue } from "vue-property-decorator";
import Logo from "./components/Logo.vue";
import SendSmsCode from "@/components/SendSmsCode/index.vue";
import { forgetPasswordConfirm } from "@/api/login";
import { validatePhoneNumber } from "@/utils/util";
import { encryptData } from "@/utils/encryptData";
import { setAllowsBackGesture } from "@/utils/h5ToApp";

@Component({
  components: { Logo, SendSmsCode }
})
export class FindPwd extends Vue {
  mobile = ''
  smsCode = ''
  businessId = ''
  errShakeClass = 'animate__animated animate__headShake'
  isMobileErr = false
  mobileErrMsg = '请输入正确的手机号码格式'
  isSmsCodeErr = false

  mounted () {
    // 禁用侧滑返回
    setAllowsBackGesture('0');
  }

  handleBack () {
    this.$router.replace('/pwdLogin')
  }

  onMobileFocus () {
    this.isMobileErr = false
  }

  onMobileBlur (value: string) {
    if (value) {
      this.isMobileErr = !validatePhoneNumber(value)
      this.mobileErrMsg = '请输入正确的手机号码格式'
    }
  }

  onSmsCodeInput () {
    this.isSmsCodeErr && (this.isSmsCodeErr = false)
  }

  onSendSmsCodeApiRes (res: any) {
    if (res.code === "000000") {
      this.businessId = res.data.businessId
    } else {
      this.mobileErrMsg = res.data.msg
      this.isMobileErr = true
    }
  }

  onNext () {
    this.isSmsCodeErr && (this.isSmsCodeErr = false)
    if (!this.businessId) {
      this.$toast("请先获取验证码");
      return
    }
    const params = {
      businessId: this.businessId,
      mobile: encryptData(this.mobile),
      smsCode: this.smsCode
    }
    forgetPasswordConfirm(params).then(() => {
      this.$router.replace(`/resetPwd?businessId=${this.businessId}&mobile=${this.mobile}&smsCode=${this.smsCode}`)
    }).catch((err) => {
      const { code, msg = '请联系管理员' } = err.data || null
      if (code === '000001') {
        if (msg.includes('验证码')) { // 验证码有误（红字提示即可）
          this.isSmsCodeErr = true
        } else { // 其他错误（toast提示）
          this.$toast(msg)
        }
      }
    })
  }
}
export default FindPwd
